import { render, staticRenderFns } from "./AffiliatesBanner.vue?vue&type=template&id=ff3ca0bc&scoped=true"
import script from "./AffiliatesBanner.vue?vue&type=script&lang=js"
export * from "./AffiliatesBanner.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesBanner.vue?vue&type=style&index=0&id=ff3ca0bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3ca0bc",
  null
  
)

export default component.exports